import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "editable-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_input, {
      onClick: _ctx.enableEditing,
      "onUpdate:modelValue": [
        _ctx.onUpdate,
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event))
      ],
      onKeydown: _withKeys(_withModifiers(_ctx.saveEdit, ["prevent"]), ["enter"]),
      modelValue: _ctx.currentValue,
      onBlur: _ctx.saveEdit,
      dense: "",
      outlined: _ctx.editing,
      ref: "inputRef",
      rules: _ctx.inputValidationRules,
      "lazy-rules": "",
      "hide-bottom-space": "",
      type: _ctx.type,
      class: _normalizeClass(_ctx.editing ? 'editable-field__active' : 'editable-field__inactive'),
      "bottom-slots": _ctx.showBottomHint,
      placeholder: _ctx.computedPlaceholder
    }, _createSlots({ _: 2 }, [
      (_ctx.showEditButtons)
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createVNode(_component_q_btn, {
                onClick: _ctx.disableEditing,
                flat: "",
                dense: "",
                round: "",
                icon: "rotate_left",
                color: "grey-5"
              }, null, 8, ["onClick"])
            ])
          }
        : undefined,
      (_ctx.showEditButtons)
        ? {
            name: "after",
            fn: _withCtx(() => [
              (_ctx.editing)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    onClick: _ctx.saveEdit,
                    flat: "",
                    dense: "",
                    round: "",
                    icon: "check_circle",
                    color: "primary"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined,
      (_ctx.showBottomHint)
        ? {
            name: "hint",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.hint), 1)
            ])
          }
        : undefined
    ]), 1032, ["onClick", "onUpdate:modelValue", "onKeydown", "modelValue", "onBlur", "outlined", "rules", "type", "class", "bottom-slots", "placeholder"]),
    (!_ctx.editing)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          onClick: _ctx.enableEditing,
          flat: "",
          dense: "",
          round: "",
          icon: "mdi-pencil-outline",
          color: "grey-7"
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}